import React from 'react';
import { useLocation } from 'react-router-dom';
import Tienda from '../../components/Tienda';
import Buscador from '../../components/Buscardor/Buscador';
import './styles.scss';

const TiendaPage = (props) => {
	const location = useLocation();
	const pathname = location ? location.pathname : '';
	const esCheckout = pathname.indexOf('checkout') !== -1;
	const esDetalleProducto = pathname.indexOf('/tienda/producto/') !== -1;
	return (
		<>
			{!esCheckout && !esDetalleProducto && <Buscador />}
			<Tienda {...props} />
		</>
	);
}

export default TiendaPage;
